// extracted by mini-css-extract-plugin
module.exports =  {"work-time":"_32bbee5fda--work-time--Au9Jn"};